import { Stack } from '@mui/material';
import { type FC } from 'react';
import { Page } from '../../Page';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const RitualEditPageSkeleton: FC = () => {
    return (
        <Page back={true} insetEnabled={false}>
            <Stack alignItems="center" justifyContent="center" minHeight="var(--tg-viewport-content-safe-area-inset-top)">
                <Stack direction="row" alignItems="center" gap={1}>
                    <ThemedSkeleton variant="rectangular" width={32} height={32} sx={{ borderRadius: '8px' }} />
                    <ThemedSkeleton variant="rectangular" width={120} height={20} sx={{ borderRadius: 1 }} />
                </Stack>
            </Stack>
            <Stack height="100%" gap="15px" paddingTop="10px" paddingLeft="10px" paddingRight="10px">
                <ThemedSkeleton variant="rectangular" width="100%" height={52} sx={{ borderRadius: '14px' }} />
                <ThemedSkeleton variant="rectangular" width="100%" height={220} sx={{ borderRadius: '14px' }} />
            </Stack>
        </Page>
    );
};

